var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.info)?_c('div',{staticClass:"map"},[_c('GmapMap',{ref:"map",staticStyle:{"width":"100%","height":"100%"},attrs:{"center":{
      lat: _vm.location.lat,
      lng: _vm.location.lng
    },"zoom":_vm.zoom}},[_c('GmapMarker',{attrs:{"position":{
        lat: _vm.location.lat,
        lng: _vm.location.lng
      },"icon":{
        url: _vm.iconUrl.place,
        scaledSize: _vm.iconSize
      }}}),_c('GmapMarker',{attrs:{"position":{
        lat: _vm.from.lat,
        lng: _vm.from.lng
      },"icon":{
        url: _vm.iconUrl.hotel,
        scaledSize: _vm.iconSize
      }}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }